var React = require('react');

function IconCloseOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 1.5C6.15 1.5 1.5 6.15 1.5 12S6.15 22.5 12 22.5 22.5 17.85 22.5 12 17.85 1.5 12 1.5zM12 21c-4.95 0-9-4.05-9-9s4.05-9 9-9 9 4.05 9 9-4.05 9-9 9z","key":0}),React.createElement("path",{"d":"M16.05 17.25L12 13.2l-4.05 4.05-1.2-1.2L10.8 12 6.75 7.95l1.2-1.2L12 10.8l4.05-4.05 1.2 1.2L13.2 12l4.05 4.05-1.2 1.2z","key":1})]);
}

IconCloseOutline.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconCloseOutline;

IconCloseOutline.default = IconCloseOutline;
